<template>
  <v-col :cols="div_cols" class="ma-0 pa-0">
    <v-card tile flat class="text-center">
      <v-img
        :aspect-ratio="16/8"
        :src="imgSrc"
      >
      <v-overlay
          absolute="absolute" opacity="0.2"
        >
        <v-row align="center" class="white--text fill-height">
          <v-spacer></v-spacer>
          <v-col>
            <v-card flat tile color="transparent" style="filter: brightness(100%);">
              <v-card-actions>
                <v-row justify="center">
                  <v-btn ref="picbtn" :ripple="ripple" depressed text :to="jumpTo" :class="font_title" style="filter: brightness(100%);">{{ title }}</v-btn>
                </v-row>
              </v-card-actions>
              <v-divider color="white"></v-divider>
              <v-card-text :class="font_subtitle" style="white-space:nowrap;">
                {{ subtitle }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        </v-overlay>
      </v-img>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "TciPicDiv",
  props: {
    imgSrc: String,
    jumpTo: String,
    title: String,
    subtitle: String,
    imgStyle: String,
    font_title: {
      default: "white--text display-1",
      type: String
    },
    font_subtitle: {
      default: "white--text title",
      type: String
    }
  },
  computed: {
    div_cols: function(){
      if(this.$vuetify.breakpoint.xs){
        return 12;
      }
      return false;
    }
  },
  data: () => ({
    "ripple":false
  }),
  mounted : function () {
    this.$refs.picbtn.ripple=false;
  }
};
</script>

<style scoped>
.v-btn:hover:before {
  background-color: transparent;
}
.v-btn:before {
  background-color: transparent !important;
  transition: none !important;
}
.v-ripple__animation {
  display: none;
}

</style>